import { __awaiter } from "tslib";
import axios from 'axios';
/**
 * Request maker for OData infinite queries with server-driven paging.
 * (i.e. the API returns a nextLink)
 */
export const queryFunctionGetEntityServerDriven = ({ nextLink, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!axios.defaults.baseURL) {
        console.error('NOT YET READY');
        throw new Error('not ready');
    }
    const response = (yield axios.get(nextLink)).data;
    return response;
});
